import React from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { Bell, ChevronDown, LogOut, Search } from 'lucide-react';
import { AdminSidebar } from './AdminSidebar';
import { usePrototype } from '../../contexts/PrototypeContext';
import { toBn } from '../../utils/bn';
export function AdminLayout() {
  const navigate = useNavigate();
  const {
    cases
  } = usePrototype();
  const newCases = cases.filter(c => c.status === 'নতুন').length;
  return <div className="flex min-h-[calc(100vh-48px)] w-full bg-background" data-id="element-74" data-mp="34z9c21p069ov">
      <AdminSidebar data-id="element-75" data-mp="39uex6yakzkbw" />
      <div className="flex min-w-0 flex-1 flex-col" data-id="element-76" data-mp="39xt0c8r2jxke">
        <header className="print-hide sticky top-12 z-30 flex h-14 items-center gap-3 border-b border-border bg-white px-5" data-id="element-77" data-mp="3ew4c4p0xci59">
          <label className="flex w-full max-w-md items-center gap-2 rounded-md border border-input bg-slate-50 px-3 py-1.5" data-id="element-78" data-mp="3ivv7l61ebmg4">
            <Search className="h-4 w-4 text-slate-400" data-id="element-79" data-mp="1kjecdqnvkepy" />
            <input placeholder="রেজিস্ট্রেশন নং, QR ID, চালক বা লাইসেন্স খুঁজুন…" className="w-full bg-transparent text-sm outline-none" aria-label="সার্বিক অনুসন্ধান" onKeyDown={e => {
            if (e.key === 'Enter') navigate('/admin/cng');
          }} data-id="element-80" data-mp="1ojeubla6n81r" />
          </label>
          <div className="ml-auto flex items-center gap-2" data-id="element-81" data-mp="2jb15tiyakfq0">
            <Link to="/admin/irregularities" className="relative flex h-9 w-9 items-center justify-center rounded-md hover:bg-slate-100" aria-label="নতুন অনিয়ম" data-id="element-82" data-mp="2jclzz7gp1wnc">
              <Bell className="h-[18px] w-[18px] text-slate-600" data-id="element-83" data-mp="3c0hvw9yfvkj2" />
              {newCases > 0 && <span className="absolute right-1 top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-red-600 px-1 text-[9px] font-bold text-white" data-id="element-84" data-mp="36zc208t1lr7y">{toBn(newCases)}</span>}
            </Link>
            <div className="mx-1 h-6 w-px bg-border" data-id="element-85" data-mp="1vmrqmzvl2q7u" />
            <button className="flex items-center gap-2 rounded-md px-2 py-1 hover:bg-slate-100" data-id="element-86" data-mp="1qmdizixw9iac">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-navy-800 text-xs font-bold text-white" data-id="element-87" data-mp="imy1fhiw4k63">শই</span>
              <span className="hidden text-left leading-tight md:block" data-id="element-88" data-mp="mmypzuzpebqv">
                <span className="block text-[13px] font-semibold text-navy-900" data-id="element-89" data-mp="8pa2sgi5ysin">মোঃ শফিকুল ইসলাম</span>
                <span className="block text-[11px] text-slate-500" data-id="element-90" data-mp="dmscwa7x3ds8">সুপার অ্যাডমিন • ট্রাফিক সদর দপ্তর</span>
              </span>
              <ChevronDown className="h-4 w-4 text-slate-400" data-id="element-91" data-mp="3v2iekgpfj5zl" />
            </button>
            <Link to="/admin/login" className="flex h-9 w-9 items-center justify-center rounded-md hover:bg-slate-100" aria-label="লগআউট" data-id="element-92" data-mp="3qfj7ccdgzxh">
              <LogOut className="h-4 w-4 text-slate-500" data-id="element-93" data-mp="3m1aj06easj97" />
            </Link>
          </div>
        </header>
        <main className="flex-1 p-5 xl:p-6" data-id="element-94" data-mp="3r03xo25bmgay">
          <Outlet data-id="element-95" data-mp="3c68sp78adb51" />
        </main>
        <footer className="print-hide border-t border-border px-6 py-3 text-[11px] text-slate-500" data-id="element-96" data-mp="3c7af27ur5k22">
          © ২০২৬ ঢাকা মেট্রোপলিটন পুলিশ • ট্রাফিক বিভাগ • প্রোটোটাইপ — প্রদর্শিত সকল তথ্য কাল্পনিক/নমুনা
        </footer>
      </div>
    </div>;
}